"use strict";

var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");

var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("@babel/runtime/helpers/getPrototypeOf");

var _typeof = require("@babel/runtime/helpers/typeof");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InnerSlider = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _initialState = _interopRequireDefault(require("./initial-state"));

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _classnames = _interopRequireDefault(require("classnames"));

var _innerSliderUtils = require("./utils/innerSliderUtils");

var _track = require("./track");

var _dots = require("./dots");

var _arrows = require("./arrows");

var _resizeObserverPolyfill = _interopRequireDefault(require("resize-observer-polyfill"));

var _excluded = ["animating"];

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];

      for (var r in t) {
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
    }

    return n;
  }, _extends.apply(null, arguments);
}

function _objectWithoutProperties(e, t) {
  if (null == e) return {};

  var o,
      r,
      i = _objectWithoutPropertiesLoose(e, t);

  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);

    for (r = 0; r < n.length; r++) {
      o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
  }

  return i;
}

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};

  for (var n in r) {
    if ({}.hasOwnProperty.call(r, n)) {
      if (-1 !== e.indexOf(n)) continue;
      t[n] = r[n];
    }
  }

  return t;
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

var InnerSlider = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(InnerSlider, _react$default$Compon);

  var _super = _createSuper(InnerSlider);

  function InnerSlider(props) {
    var _this2;

    _classCallCheck(this, InnerSlider);

    var _this;

    _this2 = _super.call(this, props);
    _this = _assertThisInitialized(_this2);

    _defineProperty(_assertThisInitialized(_this2), "listRefHandler", function (ref) {
      return _this2.list = ref;
    });

    _defineProperty(_assertThisInitialized(_this2), "trackRefHandler", function (ref) {
      return _this2.track = ref;
    });

    _defineProperty(_assertThisInitialized(_this2), "adaptHeight", function () {
      if (_this2.props.adaptiveHeight && _this2.list) {
        var elem = _this2.list.querySelector("[data-index=\"".concat(_this2.state.currentSlide, "\"]"));

        _this2.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    });

    _defineProperty(_assertThisInitialized(_this2), "UNSAFE_componentWillMount", function () {
      _this2.ssrInit();

      _this2.props.onInit && _this2.props.onInit();

      if (_this2.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this2.props), _this2.state));

        if (slidesToLoad.length > 0) {
          _this2.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this2.props.onLazyLoad) {
            _this2.props.onLazyLoad(slidesToLoad);
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this2), "componentDidMount", function () {
      var spec = _objectSpread({
        listRef: _this2.list,
        trackRef: _this2.track
      }, _this2.props);

      _this2.updateState(spec, true, function () {
        _this2.adaptHeight();

        _this2.props.autoplay && _this2.autoPlay("update");
      });

      if (_this2.props.lazyLoad === "progressive") {
        _this2.lazyLoadTimer = setInterval(_this2.progressiveLazyLoad, 1000);
      }

      _this2.ro = new _resizeObserverPolyfill.default(function () {
        if (_this2.state.animating) {
          _this2.onWindowResized(false); // don't set trackStyle hence don't break animation


          _this2.callbackTimers.push(setTimeout(function () {
            return _this2.onWindowResized();
          }, _this2.props.speed));
        } else {
          _this2.onWindowResized();
        }
      });

      _this2.ro.observe(_this2.list);

      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this2.props.pauseOnFocus ? _this2.onSlideFocus : null;
        slide.onblur = _this2.props.pauseOnFocus ? _this2.onSlideBlur : null;
      }); // To support server-side rendering

      if (!window) {
        return;
      }

      if (window.addEventListener) {
        window.addEventListener("resize", _this2.onWindowResized);
      } else {
        window.attachEvent("onresize", _this2.onWindowResized);
      }
    });

    _defineProperty(_assertThisInitialized(_this2), "componentWillUnmount", function () {
      if (_this2.animationEndCallback) {
        clearTimeout(_this2.animationEndCallback);
      }

      if (_this2.lazyLoadTimer) {
        clearInterval(_this2.lazyLoadTimer);
      }

      if (_this2.callbackTimers.length) {
        _this2.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });

        _this2.callbackTimers = [];
      }

      if (window.addEventListener) {
        window.removeEventListener("resize", _this2.onWindowResized);
      } else {
        window.detachEvent("onresize", _this2.onWindowResized);
      }

      if (_this2.autoplayTimer) {
        clearInterval(_this2.autoplayTimer);
      }

      _this2.ro.disconnect();
    });

    _defineProperty(_assertThisInitialized(_this2), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      var spec = _objectSpread(_objectSpread({
        listRef: _this2.list,
        trackRef: _this2.track
      }, nextProps), _this2.state);

      var setTrackStyle = false;

      for (var _i = 0, _Object$keys = Object.keys(_this2.props); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];

        if (!nextProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }

        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
          continue;
        }

        if (nextProps[key] !== _this2.props[key]) {
          setTrackStyle = true;
          break;
        }
      }

      _this2.updateState(spec, setTrackStyle, function () {
        if (_this2.state.currentSlide >= _react.default.Children.count(nextProps.children)) {
          _this2.changeSlide({
            message: "index",
            index: _react.default.Children.count(nextProps.children) - nextProps.slidesToShow,
            currentSlide: _this2.state.currentSlide
          });
        }

        if (nextProps.autoplay) {
          _this2.autoPlay("update");
        } else {
          _this2.pause("paused");
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "componentDidUpdate", function () {
      _this2.checkImagesLoad();

      _this2.props.onReInit && _this2.props.onReInit();

      if (_this2.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this2.props), _this2.state));

        if (slidesToLoad.length > 0) {
          _this2.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this2.props.onLazyLoad) {
            _this2.props.onLazyLoad(slidesToLoad);
          }
        }
      } // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }


      _this2.adaptHeight();
    });

    _defineProperty(_assertThisInitialized(_this2), "onWindowResized", function (setTrackStyle) {
      if (_this2.debouncedResize) _this2.debouncedResize.cancel();
      _this2.debouncedResize = (0, _lodash.default)(function () {
        return _this2.resizeWindow(setTrackStyle);
      }, 50);

      _this2.debouncedResize();
    });

    _defineProperty(_assertThisInitialized(_this2), "resizeWindow", function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (!_reactDom.default.findDOMNode(_this.track)) return;

      var spec = _objectSpread(_objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);

      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      }); // animating state should be cleared while resizing, otherwise autoplay stops working


      _this.setState({
        animating: false
      });

      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    });

    _defineProperty(_assertThisInitialized(_this2), "updateState", function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _objectSpread(_objectSpread(_objectSpread({}, spec), updatedState), {}, {
        slideIndex: updatedState.currentSlide
      });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _objectSpread(_objectSpread({}, spec), {}, {
        left: targetLeft
      });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);

      if (setTrackStyle || _react.default.Children.count(_this2.props.children) !== _react.default.Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }

      _this2.setState(updatedState, callback);
    });

    _defineProperty(_assertThisInitialized(_this2), "ssrInit", function () {
      if (_this2.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread(_objectSpread(_objectSpread({}, _this2.props), _this2.state), {}, {
          slideCount: _this2.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread(_objectSpread(_objectSpread({}, _this2.props), _this2.state), {}, {
          slideCount: _this2.props.children.length
        }));

        _this2.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });

        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }

        for (var _i2 = 0; _i2 < postClones; _i2++) {
          _trackWidth += childrenWidths[_i2];
        }

        for (var _i3 = 0; _i3 < _this2.state.currentSlide; _i3++) {
          _trackLeft += childrenWidths[_i3];
        }

        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };

        if (_this2.props.centerMode) {
          var currentWidth = "".concat(childrenWidths[_this2.state.currentSlide], "px");
          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
        }

        _this2.setState({
          trackStyle: _trackStyle
        });

        return;
      }

      var childrenCount = _react.default.Children.count(_this2.props.children);

      var spec = _objectSpread(_objectSpread(_objectSpread({}, _this2.props), _this2.state), {}, {
        slideCount: childrenCount
      });

      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this2.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this2.state.currentSlide) * trackWidth / 100;

      if (_this2.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }

      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };

      _this2.setState({
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "checkImagesLoad", function () {
      var images = document.querySelectorAll(".slick-slide img");
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this2.onWindowResized();
        };

        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;

          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }

        if (!image.onload) {
          if (_this2.props.lazyLoad) {
            image.onload = function () {
              _this2.adaptHeight();

              _this2.callbackTimers.push(setTimeout(_this2.onWindowResized, _this2.props.speed));
            };
          } else {
            image.onload = handler;

            image.onerror = function () {
              handler();
              _this2.props.onLazyLoadError && _this2.props.onLazyLoadError();
            };
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "progressiveLazyLoad", function () {
      var slidesToLoad = [];

      var spec = _objectSpread(_objectSpread({}, _this2.props), _this2.state);

      for (var index = _this2.state.currentSlide; index < _this2.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this2.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }

      for (var _index = _this2.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this2.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }

      if (slidesToLoad.length > 0) {
        _this2.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });

        if (_this2.props.onLazyLoad) {
          _this2.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this2.lazyLoadTimer) {
          clearInterval(_this2.lazyLoadTimer);
          delete _this2.lazyLoadTimer;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this2), "slideHandler", function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange; // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _ref = (0, _innerSliderUtils.slideHandler)(_objectSpread(_objectSpread(_objectSpread({
        index: index
      }, _this.props), _this.state), {}, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _ref.state,
          nextState = _ref.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);

      _this.setState(state, function () {
        asNavFor && asNavFor.innerSlider.state.currentSlide !== _this.currentSlide && asNavFor.innerSlider.slideHandler(index);
        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, _excluded);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({
                animating: animating
              });
            }, 10));

            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "changeSlide", function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;

      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
    });

    _defineProperty(_assertThisInitialized(_this2), "clickHandler", function (e) {
      if (_this2.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }

      _this2.clickable = true;
    });

    _defineProperty(_assertThisInitialized(_this2), "keyHandler", function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this2.props.accessibility, _this2.props.rtl);
      dir !== "" && _this2.changeSlide({
        message: dir
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "selectHandler", function (options) {
      _this2.changeSlide(options);
    });

    _defineProperty(_assertThisInitialized(_this2), "disableBodyScroll", function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };

      window.ontouchmove = preventDefault;
    });

    _defineProperty(_assertThisInitialized(_this2), "enableBodyScroll", function () {
      window.ontouchmove = null;
    });

    _defineProperty(_assertThisInitialized(_this2), "swipeStart", function (e) {
      if (_this2.props.verticalSwiping) {
        _this2.disableBodyScroll();
      }

      var state = (0, _innerSliderUtils.swipeStart)(e, _this2.props.swipe, _this2.props.draggable);
      state !== "" && _this2.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this2), "swipeMove", function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread(_objectSpread(_objectSpread({}, _this2.props), _this2.state), {}, {
        trackRef: _this2.track,
        listRef: _this2.list,
        slideIndex: _this2.state.currentSlide
      }));
      if (!state) return;

      if (state["swiping"]) {
        _this2.clickable = false;
      }

      _this2.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this2), "swipeEnd", function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread(_objectSpread(_objectSpread({}, _this2.props), _this2.state), {}, {
        trackRef: _this2.track,
        listRef: _this2.list,
        slideIndex: _this2.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];

      _this2.setState(state);

      if (triggerSlideHandler === undefined) return;

      _this2.slideHandler(triggerSlideHandler);

      if (_this2.props.verticalSwiping) {
        _this2.enableBodyScroll();
      }
    });

    _defineProperty(_assertThisInitialized(_this2), "slickPrev", function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this2.callbackTimers.push(setTimeout(function () {
        return _this2.changeSlide({
          message: "previous"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this2), "slickNext", function () {
      _this2.callbackTimers.push(setTimeout(function () {
        return _this2.changeSlide({
          message: "next"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this2), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      slide = Number(slide);
      if (isNaN(slide)) return "";

      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this2), "play", function () {
      var nextIndex;

      if (_this2.state.currentDirection === 0) {
        nextIndex = _this2.state.currentSlide - _this2.props.slidesToScroll;
      } else if (_this2.state.currentDirection === 1) {
        nextIndex = _this2.state.currentSlide + _this2.props.slidesToScroll;
      } else {
        if (_this2.props.rtl) {
          nextIndex = _this2.state.currentSlide - _this2.props.slidesToScroll;
        } else {
          if ((0, _innerSliderUtils.canGoNext)(_objectSpread(_objectSpread({}, _this2.props), _this2.state))) {
            nextIndex = _this2.state.currentSlide + _this2.props.slidesToScroll;
          } else {
            return false;
          }
        }
      }

      _this2.slideHandler(nextIndex);
    });

    _defineProperty(_assertThisInitialized(_this2), "autoPlay", function (playType, options) {
      if (_this2.autoplayTimer) {
        clearInterval(_this2.autoplayTimer);
      }

      if (options && options.direction) {
        _this2.setState({
          currentDirection: options.direction === "previous" ? 0 : 1
        });
      }

      var autoplaying = _this2.state.autoplaying;

      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }

      _this2.autoplayTimer = setInterval(_this2.play, _this2.props.autoplaySpeed + 50);

      _this2.setState({
        autoplaying: "playing"
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "pause", function (pauseType) {
      if (_this2.autoplayTimer) {
        clearInterval(_this2.autoplayTimer);
        _this2.autoplayTimer = null;
      }

      var autoplaying = _this2.state.autoplaying;

      if (pauseType === "paused") {
        _this2.setState({
          autoplaying: "paused"
        });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this2.setState({
            autoplaying: "focused"
          });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this2.setState({
            autoplaying: "hovered"
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this2), "onDotsOver", function () {
      return _this2.props.autoplay && _this2.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this2), "onDotsLeave", function () {
      return _this2.props.autoplay && _this2.state.autoplaying === "hovered" && _this2.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this2), "onTrackOver", function () {
      return _this2.props.autoplay && _this2.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this2), "onTrackLeave", function () {
      return _this2.props.autoplay && _this2.state.autoplaying === "hovered" && _this2.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this2), "onSlideFocus", function () {
      return _this2.props.autoplay && _this2.pause("focused");
    });

    _defineProperty(_assertThisInitialized(_this2), "onSlideBlur", function () {
      return _this2.props.autoplay && _this2.state.autoplaying === "focused" && _this2.autoPlay("blur");
    });

    _defineProperty(_assertThisInitialized(_this2), "getCurrentSlide", function () {
      return _this2.state.currentSlide;
    });

    _defineProperty(_assertThisInitialized(_this2), "render", function () {
      var className = (0, _classnames.default)("slick-slider", _this2.props.className, {
        "slick-vertical": _this2.props.vertical,
        "slick-initialized": true
      });

      var spec = _objectSpread(_objectSpread({}, _this2.props), _this2.state);

      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
      var pauseOnHover = _this2.props.pauseOnHover;
      trackProps = _objectSpread(_objectSpread({}, trackProps), {}, {
        onMouseEnter: pauseOnHover ? _this2.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this2.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this2.onTrackOver : null,
        focusOnSelect: _this2.props.focusOnSelect ? _this2.selectHandler : null
      });
      var dots;

      if (_this2.props.dots === true && _this2.state.slideCount >= _this2.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this2.props.pauseOnDotsHover;
        dotProps = _objectSpread(_objectSpread({}, dotProps), {}, {
          clickHandler: _this2.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this2.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this2.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this2.onDotsLeave : null
        });
        dots = /*#__PURE__*/_react.default.createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this2.changeSlide;

      if (_this2.props.arrows) {
        prevArrow = /*#__PURE__*/_react.default.createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = /*#__PURE__*/_react.default.createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this2.props.vertical) {
        verticalHeightStyle = {
          height: _this2.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this2.props.vertical === false) {
        if (_this2.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this2.props.centerPadding
          };
        }
      } else {
        if (_this2.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this2.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _objectSpread(_objectSpread({}, verticalHeightStyle), centerPaddingStyle);

      var touchMove = _this2.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this2.clickHandler,
        onMouseDown: touchMove ? _this2.swipeStart : null,
        onMouseMove: _this2.state.dragging && touchMove ? _this2.swipeMove : null,
        onMouseUp: touchMove ? _this2.swipeEnd : null,
        onMouseLeave: _this2.state.dragging && touchMove ? _this2.swipeEnd : null,
        onTouchStart: touchMove ? _this2.swipeStart : null,
        onTouchMove: _this2.state.dragging && touchMove ? _this2.swipeMove : null,
        onTouchEnd: touchMove ? _this2.swipeEnd : null,
        onTouchCancel: _this2.state.dragging && touchMove ? _this2.swipeEnd : null,
        onKeyDown: _this2.props.accessibility ? _this2.keyHandler : null
      };
      var innerSliderProps = {
        className: className,
        dir: "ltr"
      };

      if (_this2.props.unslick) {
        listProps = {
          className: "slick-list"
        };
        innerSliderProps = {
          className: className
        };
      }

      return /*#__PURE__*/_react.default.createElement("div", innerSliderProps, !_this2.props.unslick ? prevArrow : "", !_this2.props.unslick ? nextArrow : "", /*#__PURE__*/_react.default.createElement("div", _extends({
        ref: _this2.listRefHandler
      }, listProps), /*#__PURE__*/_react.default.createElement(_track.Track, _extends({
        ref: _this2.trackRefHandler
      }, trackProps), _this2.props.children)), !_this2.props.unslick ? dots : "");
    });

    _this2.list = null;
    _this2.track = null;
    _this2.state = _objectSpread(_objectSpread({}, _initialState.default), {}, {
      currentSlide: _this2.props.initialSlide,
      slideCount: _react.default.Children.count(_this2.props.children)
    });
    _this2.callbackTimers = [];
    _this2.clickable = true;
    _this2.debouncedResize = null;
    return _this2;
  }

  return InnerSlider;
}(_react.default.Component);

exports.InnerSlider = InnerSlider;